import { Link } from "react-router-dom";

// Single source of truth for the Yonsii Geek Support brand mark.
// The image itself already contains the company name — no adjacent text is ever rendered.
const LOGO_SRC = "/logo.png";

/**
 * <Logo /> — brand mark for the app.
 *
 * Variants:
 *   "nav"   → 45px tall, wraps in a Link to /   (used in the site navbar)
 *   "auth"  → centered block, max-width 180px  (used on login / register / admin-login pages)
 *   "inline"→ 45px tall, no link                (used inside the site footer)
 */
export default function Logo({ variant = "nav", testId = "brand-logo", className = "" }) {
  if (variant === "auth") {
    return (
      <div className={`flex justify-center ${className}`}>
        <img
          src={LOGO_SRC}
          alt="Yonsii Geek Support"
          data-testid={testId}
          style={{ maxWidth: "180px", width: "auto", height: "auto", objectFit: "contain" }}
        />
      </div>
    );
  }
  if (variant === "inline") {
    return (
      <img
        src={LOGO_SRC}
        alt="Yonsii Geek Support"
        data-testid={testId}
        style={{ maxHeight: "40px", height: "40px", width: "auto", objectFit: "contain" }}
        className={className}
      />
    );
  }
  // default: nav
  return (
    <Link to="/" data-testid={testId} className={`inline-flex items-center ${className}`}>
      <img
        src={LOGO_SRC}
        alt="Yonsii Geek Support"
        style={{ height: "45px", width: "auto", objectFit: "contain" }}
      />
    </Link>
  );
}
